import { Injectable } from '@angular/core';
import { Action, createSelector, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { defaultUiContentState, IUiContentState } from '../models';
import { UiContentDataService } from '../ui-content.data-service';
import { UiContentActions } from './ui-content.action';

@State<IUiContentState>({
  name: 'uicontent',
  defaults: defaultUiContentState,
})
@Injectable()
export class UiContentState {
  constructor(private dataService: UiContentDataService) {}

  public static translation(key: string) {
    return createSelector([UiContentState], (state: IUiContentState) => {
      return state.brandContent?.[key] || '';
    });
  }

  /**
   * Action handler to fetch the brand configuration
   * @param ctx
   */
  @Action(UiContentActions.LoadBrandContent)
  loadBrandContent(
    ctx: StateContext<IUiContentState>,
    { brand }: UiContentActions.LoadBrandContent
  ): Observable<any> {
    return this.dataService.loadBrandContent(brand).pipe(
      tap((data) => {
        ctx.patchState({ brandContent: { ...data } });
      })
    );
  }
}
